import { HEATING_SYSTEM_EXCHANGE_SYSTEM_BY_KEY } from "./heating-system-exchange-system-by-key";
export const computeHeatingSystemExchangeConversionFactor = ({ existingSystem, newSystem, }) => HEATING_SYSTEM_EXCHANGE_SYSTEM_BY_KEY[newSystem].newPlantExpenditureFactor /
    HEATING_SYSTEM_EXCHANGE_SYSTEM_BY_KEY[existingSystem].existingPlantExpenditureFactor;
